import { actionCreatorFactory } from 'typescript-fsa';
import { PersistedUser } from 'da-pcc-frontend-shared-domain';

const createAction = actionCreatorFactory('SESSION');
const fetchProfile = createAction.async<void, PersistedUser, Error>('FETCH');

export { fetchProfile };
